import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import axiosInstance from "../../api/axiosInstance";
import Card from "@material-ui/core/Card";
import AppBar from "@material-ui/core/AppBar";
import { apiurl } from "../../App";
import NotFound from "../../assets/images/NotFound.svg";
import './Notification.css';

import Cookies from "js-cookie";

class NotificationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Var_NotificationData: [],
            Var_NoData: [],
            loading: true,
            Var_DoctorDetailShow: null,
            Var_Dates: new Date().toLocaleDateString('fr-CA'),
            Var_getClinicWiseDoctor: [],
            Var_doctorSpecialitySelect: "",
            Var_specialityid: null,
            currentDate: new Date(),
        };
    }

    componentDidMount() {
        this.newNotification();
    }

    handleOnClick = (path) => {
        this.props.history.push("/Home" + path);
    };

    newNotification = () => {
        const pharmId = Cookies.get("pharmacy_id") || localStorage.getItem("pharmacy_id");
        if (pharmId) {
            axiosInstance({
                method: "POST",
                url: apiurl + "admin/notification_list",
                data: {
                    vendor_id: pharmId,
                },
            }).then((response) => {
                if (response.data && response.data.data && Array.isArray(response.data.data)) {
                    for (let i = 0; i < response.data.data.length; i++) {
                        if (response.data.data[i].created_on != '' && response.data.data[i].created_on != null) {
                            const dateTimeString = response.data.data[i].created_on;
                            const dateObject = new Date(dateTimeString);
                            const year = dateObject.getFullYear();
                            const month = String(dateObject.getMonth() + 1).padStart(2, '0');
                            const day = String(dateObject.getDate()).padStart(2, '0');
                            const hours = String(dateObject.getHours()).padStart(2, '0');
                            const minutes = String(dateObject.getMinutes()).padStart(2, '0');
                            const seconds = String(dateObject.getSeconds()).padStart(2, '0');
                            const date = `${year}-${month}-${day}`;
                            const time = `${hours}:${minutes}:${seconds}`;
                            response.data.data[i].notification_date = (date) ? this.formatDate(date) : '';
                            response.data.data[i].time = (time) ? this.formatTime(time) : '';
                        }
                    }
                    this.setState({
                        Var_NotificationData: response.data.data,
                        loading: false
                    });
                } else {
                    this.setState({
                        Var_NotificationData: [],
                        loading: false
                    });
                }
            })
                .catch((error) => {
                    console.error(JSON.stringify(error));
                    this.setState({ loading: false });
                });
        } else {
            this.setState({ Var_NotificationData: [], loading: false });
        }
    }

    formatDate(inputDate) {
        let dateParts = inputDate.split("-");
        let year = dateParts[0].substring(2);
        let month = parseInt(dateParts[1], 10);
        let day = parseInt(dateParts[2], 10);
        let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let formattedDate = day.toString().padStart(2, '0') + "-" + monthNames[month - 1] + "-" + year;
        return formattedDate;
    }

    formatTime(inputTime) {
        let timeParts = inputTime.split(":");
        let hours = parseInt(timeParts[0], 10);
        let minutes = timeParts[1];
        let amOrPm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12 || 12;
        let formattedTime = hours.toString().padStart(2, '0') + ":" + minutes + " " + amOrPm;
        return formattedTime;
    }

    notificationNavLink(data) {
        console.log(data);
        const dec = data.description.includes("deposited into your account")
        switch (data.content_type) {
            case "Booking":
                this.handleOnClick("/pending_orders")
                break;
            case "Ticket":
                this.handleOnClick("/ticket")
                break;
            case "Cancel":
                this.handleOnClick("/cancelorders")
                break;
            case null:
                if (dec) {
                    this.handleOnClick("/revenue")
                }
                break;
        }
    }

    render() {
        const { loading, Var_NotificationData, Var_NoData } = this.state;
        const { currentDate } = this.state;
        const year = currentDate.getFullYear();
        const month = ('0' + (currentDate.getMonth() + 1)).slice(-2);
        const day = ('0' + currentDate.getDate()).slice(-2);
        const formattedDate = `${year}-${month}-${day}`;

        return (
            <AppBar
                position="fixed"
            >
                <div>
                    <div className="sub_header">
                        <div className="sub_header_body">
                            <div className="back_navigation" onClick={() => this.handleOnClick("/dashboard")}>
                                <i className="fa fa-angle-left" aria-hidden="true"></i>
                                <span>NOTIFICATION</span>
                            </div>
                            <div className="flex_grow"></div>
                            <div className="header_right_content"></div>
                        </div>
                    </div>
                    <div className='content_view' style={{ boxShadow: 'none !important' }}>
                        {Var_NotificationData.length > 0 &&
                            Var_NotificationData.map((item, i) => (
                                <Card className='notification_content_card' onClick={() => this.notificationNavLink(item)} key={i}>
                                    <div className="d_flex">
                                        <div className="notification_content">
                                            <p className='email_id content'>{item.description}</p>
                                        </div>
                                        <div className="email_id content_time">{item.notification_date + ', ' + item.time}</div>
                                    </div>
                                </Card>
                            ))
                        }
                        {
                            Var_NotificationData === 0 &&
                            <div style={{ display: Var_NoData, height: "70vh" }}>
                                <p className="cancel_no_data">
                                    <img src={NotFound} className="cancel_no_data_image" alt="No Data Found" />
                                    No Data Found
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </AppBar>
        )
    }
}

export default withTranslation()(NotificationComponent);
